import { Stack, Text } from '@mantine/core';

interface IChatConversationEmptyStateProps {
  size?: 'sm' | 'md';
}

export function ChatConversationEmptyState({
  size,
}: IChatConversationEmptyStateProps) {
  const isNormalSize = size === 'md';

  return (
    <Stack gap="0.1rem" maw="22rem">
      <Text fw="bold" ta="center" fz={isNormalSize ? 'xl' : 'md'}>
        Percakapanmu masih kosong!
      </Text>
      <Text ta="center" c="dimmed" fz={isNormalSize ? 'sm' : 'xs'}>
        Tekan tombol 'Muat Ulang' untuk melihat apakah ada orang lain yang baru
        saja menghubungi kamu.
      </Text>
    </Stack>
  );
}
